import { useDebug } from '../contexts/DebugContext';

export const useDebugInfo = (componentName: string) => {
  const { debugMode, addDebugInfo, getDebugInfo } = useDebug();

  const log = (key: string, data: any) => {
    if (debugMode) {
      const fullKey = `${componentName}.${key}`;
      addDebugInfo(fullKey, data);
      console.log(`[DEBUG ${componentName}] ${key}:`, data);
    }
  };

  const logApiRequest = (url: string, method: string, data?: any) => {
    log('api.request', {
      url,
      method,
      data,
      timestamp: new Date().toISOString()
    });
  };

  const logApiResponse = (url: string, response: any, status: number) => {
    log('api.response', {
      url,
      response,
      status,
      timestamp: new Date().toISOString()
    });
  };

  const logApiError = (url: string, error: any) => {
    log('api.error', {
      url,
      error: {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        stack: error.stack
      },
      timestamp: new Date().toISOString()
    });
  };

  const logFormData = (stepName: string, data: any) => {
    log(`form.${stepName}`, {
      data,
      timestamp: new Date().toISOString()
    });
  };

  const logUserAction = (action: string, data?: any) => {
    log('user.action', {
      action,
      data,
      timestamp: new Date().toISOString()
    });
  };

  const logError = (errorType: string, error: any) => {
    log(`error.${errorType}`, {
      error: {
        message: error.message,
        stack: error.stack,
        ...error
      },
      timestamp: new Date().toISOString()
    });
  };

  const getDebugData = (key: string) => {
    return getDebugInfo(`${componentName}.${key}`);
  };

  return {
    debugMode,
    log,
    logApiRequest,
    logApiResponse,
    logApiError,
    logFormData,
    logUserAction,
    logError,
    getDebugData
  };
};
